import * as React from 'react';
import { Control, LocalForm, Errors, Field } from "react-redux-form";
import * as classNames from "classnames";
import { withTheme } from '../../common/withTheme';
import { matchingPassword, isWeakPassword, validEmail } from "../Common/validators";
import { showErrors } from "../Data/Survey/controls/ReactReduxFormSettings";
import * as Configuration from '../../configuration';
import Loader from "react-loaders";

export interface IRegisterFormItem {
    title: string;
    required: boolean;
    maxLength?: number;

    model: string;
}

interface IRegisterFormActions {
    registerUser: Function;
}

interface IRegisterFormProps {
    theme?: string;
    className?: string;
    registering: boolean;

    userAgreementTerms?: any;
    userAgreementCheckboxText?: string;

    hiddenFieldModel?: string;
    hiddenFieldValue?: any;

    formItems?: IRegisterFormItem[];
    formItemClassName?: string;
}

interface IRegisterFormState {
    showForm: boolean;
}

export type RegisterFormPropsAndActions = IRegisterFormProps & IRegisterFormActions;

class RegisterForm extends React.PureComponent<RegisterFormPropsAndActions, IRegisterFormState> {
    constructor(props, context) {
        super(props, context);

        this.state = { showForm: false };
    }

    onSubmit(user) {
        this.props.registerUser(user);
    }

    render() {

        const formItems = this.props.formItems ? this.props.formItems.map((item, i) => {
            return [
                <label key={`form-item-${i}-title`} className="lead my-0">{item.title}{item.required ? '*' : ''}</label>,
                <Control.text
                    key={`form-item-${i}-input`}
                    model={item.model}
                    id={item.model}
                    className={classNames(this.props.formItemClassName, "form-control")}
                    maxLength={item.maxLength}
                    required={item.required}
                />
            ];
        }) : undefined;

        return (
            <LocalForm
                model="user"
                onSubmit={user =>
                    this.onSubmit(user)
                }
                //getDispatch={dispatch => { this.formDispatch = dispatch; dispatch(actions.load('user', this.props.item)); }}
                validateOn="submit"
                className={classNames("form", this.props.className, "register-form", { "show-form": this.state.showForm })}
                validators={{
                    '': {
                        matching: matchingPassword,
                        isWeakPassword: isWeakPassword
                    }
                }}
            >
                <div className="form-fields">
                    {this.props.hiddenFieldValue && this.props.hiddenFieldModel ?
                        <Control.text
                            model={this.props.hiddenFieldModel}
                            id={this.props.hiddenFieldModel}
                            defaultValue={this.props.hiddenFieldValue}
                            readOnly
                            className="d-none"
                        /> : undefined
                    }

                    <label className="lead my-0">Email*</label>
                    <Control.text
                        model=".email"
                        id="email"
                        className={classNames(this.props.formItemClassName, "form-control")}
                        maxLength={100}
                        required={true}
                        validators={{
                            validEmail: validEmail
                        }}
                        validateOn={"blur"}
                    />
                    <Errors
                        className="text-danger"
                        model="user.email"
                        messages={{
                            validEmail: "Invalid email. Please check you have entered it correctly."
                        }}
                        show={showErrors}
                        component={(props) => props.children}
                    />

                    <label className="lead my-0">First Name*</label>
                    <Control.text
                        model=".fullName"
                        id="fullName"
                        className={classNames(this.props.formItemClassName, "form-control")}
                        maxLength={100}
                        required={true}
                    />

                    <label className="lead my-0">Surname*</label>
                    <Control.text
                        model=".surname"
                        id="surname"
                        className={classNames(this.props.formItemClassName, "form-control")}
                        maxLength={100}
                        required={true}
                    />

                    {formItems}

                    <label className="lead my-0">Password*</label>
                    (at least 8 characters using both upper case and lower case)
                    <Control.text
                        model=".password"
                        id="password"
                        type="password"
                        className={classNames(this.props.formItemClassName, "form-control")}
                        maxLength={100}
                        required={true}
                        validators={{
                            isWeakPassword: isWeakPassword
                        }}
                        validateOn={"blur"}
                    />
                    <Errors
                        className="text-danger"
                        model="user.password"
                        messages={{
                            isWeakPassword: "Weak password. Use at least 8 characters of both upper case and lower case."
                        }}
                        show={showErrors}
                        component={(props) => props.children}
                    />

                    <label className="lead my-0">Repeat Password*</label>
                    <Control.text
                        model=".passwordConfirm"
                        id="passwordConfirm"
                        type="password"
                        className={classNames(this.props.formItemClassName, "form-control")}
                        maxLength={100}
                        required={true}
                    />

                    {this.props.userAgreementTerms ?
                        <>
                            <label className="lead my-0">User Agreement*</label>
                            <div className="form-check m-2">
                                {this.props.userAgreementTerms}
                                <Control.checkbox
                                    model=".agreedTerms"
                                    id="agreedTerms"
                                    className="form-check-input"
                                    required={true}
                                />
                                <label className="form-check-label">{this.props.userAgreementCheckboxText}</label>
                            </div>
                        </>
                        : undefined
                    }

                    <Errors
                        className="alert alert-warning p-1"
                        model="user"
                        messages={{
                            matching: "Passwords do not match."
                        }}
                        show={showErrors}
                        component={(props) => <><i className="fa fa-warning p-2"></i>{props.children}</>}
                    />
                    <Errors
                        className="alert alert-warning p-1"
                        model="user.password"
                        messages={{
                            isWeakPassword: "Weak password. Use at least 8 characters of both upper case and lower case."
                        }}
                        show={{submitFailed: true}}
                        component={(props) => <><i className="fa fa-warning p-2"></i>{props.children}</>}
                    />
                    <Errors
                        className="alert alert-warning p-1"
                        model="user.email"
                        messages={{
                            validEmail: "Invalid email. Please check you have entered it correctly."
                        }}
                        show={{submitFailed: true}}
                        component={(props) => <><i className="fa fa-warning p-2"></i>{props.children}</>}
                    />

                    {
                        this.props.registering ? <div className="position-absolute ml-4 ml-md-5"
                            style={{ opacity: 0.75, zIndex: 80, bottom: '15px' }}>
                            <Loader type="ball-scale-multiple" active />
                            <div className="ml-4 small" style={{ color: Configuration.custom.defaultGraphColors[0] }}>please wait, registering</div>
                        </div> : undefined
                    }

                    <button className={`${this.props.theme} btn btn-primary btn-lg mt-2 align-self-end`} disabled={this.props.registering}>
                        REGISTER
                    </button>
                </div>
            </LocalForm>
        );
    }
}

export default withTheme<RegisterFormPropsAndActions>(RegisterForm);
